import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#623C9F',
                secondary: '#EBF1F3',
                accent: colors.indigo.base
            },
        },
    },
});
